export const TrustScoreAndReviews = ({
  trustScore,
  totalReviews
}: {
  trustScore?: number;
  totalReviews?: number;
}) => <div className="flex flex-row gap-1 font-sans text-gray-950 text-sm dark:text-white" data-sentry-component="TrustScoreAndReviews" data-sentry-source-file="TrustScoreAndReviews.tsx">
    <div className="flex flex-row gap-1">
      TrustScore{' '}
      <span className="font-semibold">{trustScore?.toString() ?? '4.7'}</span>
    </div>
    <span className="font-semibold">|</span>
    <span className="flex flex-row gap-1">
      <span className="font-semibold">
        {new Intl.NumberFormat().format(totalReviews ?? 1573)}
      </span>{' '}
      reviews
    </span>
  </div>;